/**
 * Contact Form Block Frontend JavaScript
 * 
 * @package Modern_Blocks
 * @since 1.0.0
 */
import './frontend.css';

document.addEventListener('DOMContentLoaded', function() {
	// Initialize contact form enhancements
	//initContactFormEnhancements();
});

/**
 * Initialize contact form enhancements
 */
function initContactFormEnhancements() {
	const contactForms = document.querySelectorAll('.contact-form-section .wpcf7-form');
	
	contactForms.forEach(form => {
		// Add smooth focus transitions
		const inputs = form.querySelectorAll('input, textarea');
		inputs.forEach(input => {
			input.addEventListener('focus', function() {
				this.parentElement.classList.add('focused');
			});
			
			input.addEventListener('blur', function() {
				if (!this.value) {
					this.parentElement.classList.remove('focused');
				}
			});
		});
		
		// Add form submission loading state
		form.addEventListener('wpcf7submit', function(event) {
			const submitButton = form.querySelector('input[type="submit"]');
			if (submitButton) {
				submitButton.disabled = true;
				submitButton.value = 'Sending...';
				submitButton.classList.add('opacity-75', 'cursor-not-allowed');
			}
		});
		
		// Reset form state after submission
		form.addEventListener('wpcf7mailsent', function(event) {
			const submitButton = form.querySelector('input[type="submit"]');
			if (submitButton) {
				submitButton.disabled = false;
				submitButton.value = 'Send Message';
				submitButton.classList.remove('opacity-75', 'cursor-not-allowed');
			}
		});
		
		// Reset form state on validation errors
		form.addEventListener('wpcf7invalid', function(event) {
			const submitButton = form.querySelector('input[type="submit"]');
			if (submitButton) {
				submitButton.disabled = false;
				submitButton.value = 'Send Message';
				submitButton.classList.remove('opacity-75', 'cursor-not-allowed');
			}
		});
	});
}
